import { useEffect } from 'react';
import { Module } from '../services/moduleService';
import { useModuleStore } from '../stores/useModuleStore';

interface UseModulesReturn {
  modules: Module[];
  loaded: boolean;
  isModuleVisible: (slug: string) => boolean;
  getModuleStatus: (slug: string) => Module['status'] | null;
  refresh: () => Promise<void>;
}

export const useModules = (): UseModulesReturn => {
  const modules = useModuleStore((s) => s.modules);
  const loaded = useModuleStore((s) => s.loaded);
  const fetch = useModuleStore((s) => s.fetch);
  const isModuleVisible = useModuleStore((s) => s.isModuleVisible);
  const getModuleStatus = useModuleStore((s) => s.getModuleStatus);

  useEffect(() => {
    fetch();
  }, [fetch]);

  return {
    modules,
    loaded,
    isModuleVisible,
    getModuleStatus,
    refresh: () => fetch(true),
  };
};
